import React, { useState } from "react";
import {Link} from 'react-router-dom';
const MsgBox = ({ avatar1, avatar2, openMsg, PerfectScrollbar, offMsg, message }) => {
   const [toggle, setToggle] = useState(false);
   
   if (!message) return null;
   
   // Get initials from name
   const getInitials = (name) => {
      return name
         .split(' ')
         .map(n => n[0])
         .join('')
         .toUpperCase()
         .substring(0, 2)
   };
   
   // Format date
   const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', { 
         day: '2-digit', 
         month: 'long', 
         year: 'numeric',
         hour: '2-digit',
         minute: '2-digit'
      });
   };
   
   return (
      <div
         className={`card chat dlab-chat-history-box ${openMsg ? "" : "d-none"}`}
      >
         <div className="card-header chat-list-header text-center">
            <Link to={"#"}
               className="dlab-chat-history-back"
               onClick={() => offMsg()}
            >
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="18px"
                  height="18px"
                  viewBox="0 0 24 24"
                  version="1.1"
               >
                  <g
                     stroke="none"
                     strokeWidth="1"
                     fill="none"
                     fillRule="evenodd"
                  >
                     <polygon points="0 0 24 0 24 24 0 24" />
                     <rect
                        fill="#000000"
                        opacity="0.3"
                        transform="translate(15.000000, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-15.000000, -12.000000) "
                        x="14"
                        y="7"
                        width="2"
                        height="10"
                        rx="1"
                     />
                     <path
                        d="M3.7071045,15.7071045 C3.3165802,16.0976288 2.68341522,16.0976288 2.29289093,15.7071045 C1.90236664,15.3165802 1.90236664,14.6834152 2.29289093,14.2928909 L8.29289093,8.29289093 C8.67146987,7.914312 9.28105631,7.90106637 9.67572234,8.26284357 L15.6757223,13.7628436 C16.0828413,14.136036 16.1103443,14.7686034 15.7371519,15.1757223 C15.3639594,15.5828413 14.7313921,15.6103443 14.3242731,15.2371519 L9.03007346,10.3841355 L3.7071045,15.7071045 Z"
                        fill="#000000"
                        fillRule="nonzero"
                        transform="translate(9.000001, 11.999997) scale(-1, -1) rotate(90.000000) translate(-9.000001, -11.999997) "
                     />
                  </g>
               </svg>
            </Link>
            <div>
               <h6 className="mb-1">{message.name}</h6>
               <p className="mb-0">
                  <span className={`badge badge-${message.status === 'new' ? 'success' : 'secondary'}`}>
                     {message.status === 'new' ? 'Nouveau' : message.status === 'read' ? 'Lu' : 'Répondu'}
                  </span>
               </p>
            </div>
            <div className="dropdown">
               <Link to={"#"}
                  data-toggle="dropdown"
                  aria-expanded="false"
                  onClick={() => setToggle(!toggle)}
               >
                  <svg
                     xmlns="http://www.w3.org/2000/svg"
                     xmlnsXlink="http://www.w3.org/1999/xlink"
                     width="18px"
                     height="18px"
                     viewBox="0 0 24 24"
                     version="1.1"
                  >
                     <g
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                     >
                        <rect x="0" y="0" width="24" height="24" />
                        <circle fill="#000000" cx="5" cy="12" r="2" />
                        <circle fill="#000000" cx="12" cy="12" r="2" />
                        <circle fill="#000000" cx="19" cy="12" r="2" />
                     </g>
                  </svg>
               </Link>
               <ul
                  className={`dropdown-menu dropdown-menu-right ${
                     toggle ? "show" : ""
                  }`}
               >
                  <li
                     className="dropdown-item"
                     onClick={() => setToggle(false)}
                  >
                     <i className="fa fa-user-circle text-primary me-2"></i>{" "}
                     View profile
                  </li>
                  <li
                     className="dropdown-item"
                     onClick={() => setToggle(false)}
                  >
                     <i className="fa fa-users text-primary me-2"></i> Add to
                     close friends
                  </li>
                  <li
                     className="dropdown-item"
                     onClick={() => setToggle(false)}
                  >
                     <i className="fa fa-plus text-primary me-2"></i> Add to
                     group
                  </li>
                  <li
                     className="dropdown-item"
                     onClick={() => setToggle(false)}
                  >
                     <i className="fa fa-ban text-primary me-2"></i> Block
                  </li>
               </ul>
            </div>
         </div>
         <PerfectScrollbar
            className={`card-body msg_card_body dlab-scroll ${
               openMsg ? "ps ps--active-y" : ""
            } `}
            id="DZ_W_Contacts_Body3"
         >
            {/* Message details */}
            <div className="mb-4 p-3 bg-light rounded">
               <h6 className="mb-3">Informations du contact</h6>
               <div className="row">
                  <div className="col-12 mb-2">
                     <strong>Nom:</strong> {message.name}
                  </div>
                  <div className="col-12 mb-2">
                     <strong>Email:</strong> <a href={`mailto:${message.email}`}>{message.email}</a>
                  </div>
                  {message.phone && (
                     <div className="col-12 mb-2">
                        <strong>Téléphone:</strong> <a href={`tel:${message.phone}`}>{message.phone}</a>
                     </div>
                  )}
                  <div className="col-12 mb-2">
                     <strong>Date:</strong> {formatDate(message.created_at)}
                  </div>
                  <div className="col-12 mb-2">
                     <strong>Statut:</strong>{' '}
                     <span className={`badge badge-${message.status === 'new' ? 'success' : 'secondary'}`}>
                        {message.status === 'new' ? 'Nouveau' : message.status === 'read' ? 'Lu' : 'Répondu'}
                     </span>
                  </div>
               </div>
            </div>
            
            {/* Subject */}
            <div className="mb-4">
               <h6 className="mb-2">Sujet</h6>
               <p className="font-weight-bold">{message.subject}</p>
            </div>
            
            {/* Message content */}
            <div className="d-flex justify-content-start mb-4">
               <div className="img_cont_msg">
                  <div className="rounded-circle user_img_msg d-flex align-items-center justify-content-center" 
                       style={{background: '#007A33', color: '#fff', fontWeight: 'bold', width: '50px', height: '50px'}}>
                     {getInitials(message.name)}
                  </div>
               </div>
               <div className="msg_cotainer">
                  <div style={{whiteSpace: 'pre-wrap'}}>{message.message}</div>
                  <span className="msg_time">{formatDate(message.created_at)}</span>
               </div>
            </div>
            
            {/* Admin notes if any */}
            {message.admin_notes && (
               <div className="d-flex justify-content-end mb-4">
                  <div className="msg_cotainer_send">
                     <strong>Note admin:</strong><br/>
                     <div style={{whiteSpace: 'pre-wrap'}}>{message.admin_notes}</div>
                     <span className="msg_time_send">{message.replied_at ? formatDate(message.replied_at) : ''}</span>
                  </div>
                  <div className="img_cont_msg">
                     <img
                        src={avatar2}
                        className="rounded-circle user_img_msg"
                        alt=""
                     />
                  </div>
               </div>
            )}
         </PerfectScrollbar>
         <div className="card-footer type_msg">
            <div className="input-group">
               <textarea
                  className="form-control"
                  placeholder="Répondre au message..."
               ></textarea>
               <div className="input-group-append">
                  <button type="button" className="btn btn-primary">
                     <i className="fa fa-paper-plane"></i>
                  </button>
               </div>
            </div>
         </div>
      </div>
   );
};

export default MsgBox;
